import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { GAME_ENTRY_FEE_LIST } from 'src/constants/queryKeys';

export const networkGetGameEntryFeeList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GameEntryFee/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGameEntryFeeList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [GAME_ENTRY_FEE_LIST, payload, pageIndex],
    queryFn: () => networkGetGameEntryFeeList(payload, pageIndex, pageSize),
  });
}

export const networkCreateGameEntryFee = async (data) => {
  const res = await axiosInstance.post('GameEntryFee/Insert', data);
  return res;
};

export const networkUpdateGameEntryFee = async (gameId, data) => {
  const res = await axiosInstance.post(`GameEntryFee/Update/${gameId}`, data);
  return res;
};

export const networkRemoveGameEntryFee = async (gameId) => {
  const res = await axiosInstance.post(`GameEntryFee/Remove/${gameId}`);
  return res;
};

export const networkCheckRequirementGame = async (gameId) => {
  const res = await axiosInstance.post(`GameEntryFee/CheckRequirement/${gameId}`);
  return res;
};

export const networkReduceGame = async (gameId) => {
  const res = await axiosInstance.post(`GameEntryFee/Reduce/${gameId}`);
  return res;
};
